module.exports = require('./lib/initials')
